module.exports = __webpack_public_path__ + "img/bg-children-day-mobile.2706ff02.png";